// The Contact-step fields a checkout profile can attach a note to. Each note is a
// per-language profile text stored under `contact_note_<key>` (see SHORT_FIELDS in
// editCheckoutProfile.vue); the client renders it under the matching input.
// `langKey` points at the CLIENT locale key for the field's label so the editor and
// the live checkout name the fields identically.
// NOTE: the client copies this exact key list in App.vue (contact_note_* → globalinfo);
// keep the two lists in sync when adding fields.
export const CONTACT_NOTE_FIELDS = [
  { key: 'gender', langKey: 'checkout_gender', fallback: 'Title' },
  { key: 'firstName', langKey: 'checkout_firstname', fallback: 'First Name' },
  { key: 'lastName', langKey: 'checkout_lastname', fallback: 'Last Name' },
  { key: 'companyName', langKey: 'checkout_company', fallback: 'Company' },
  { key: 'email', langKey: 'checkout_email', fallback: 'Email' },
  { key: 'phone', langKey: 'checkout_phone', fallback: 'Phone' },
  { key: 'mobilePhone', langKey: 'checkout_mobile', fallback: 'Mobile' },
  { key: 'address1', langKey: 'checkout_address', fallback: 'Address' },
  { key: 'postalCode', langKey: 'checkout_zip', fallback: 'Postal Code' },
  { key: 'city', langKey: 'checkout_city', fallback: 'City' },
  { key: 'country', langKey: 'checkout_country', fallback: 'Country' },
];

/** The profile-text key holding a field's note. */
export function contactNoteKey(fieldKey) {
  return 'contact_note_' + fieldKey;
}

export default CONTACT_NOTE_FIELDS;
